export const seoIntroPage = {
  title:
    "Igor Swara - One Artist, Three Portals – Explore Unique Electronic Soundscapes",
  description:
    "Step into a world of immersive electronic music. Explore three distinct projects — Hardcore Buddhist, Swaratrip, and Mindsex—each offering a unique sonic journey through psybient, progressive chillout, psytrance, and melodic techno. Follow the flow and discover the soundscapes shaping the future of electronic music.",
  keywords: [
    "Psybient",
    "Psychedelic Chill Out",
    "Psytrance",
    "Goa trance",
    "Melodic house & techno",
    "Progressive Trance",
    "Music Producer",
    "Composer",
    "Electronic Music Producer",
    "Chillout Music",
    "Progressive Chillout",
    "Electronica",
    "Downtempo",
    "Experimental Electronic Music",
    "Psychedelic trance",
    "Psytrance",
    "Goa trance",
    "Netherlands",
    "Ukraine",
  ],
};

export const seoConfig = {
  hardcorebuddhist: {
    homepage: {
      title:
        "Hardcore Buddhist | Official Website – Psybient & Progressive Chill Out Music",
      description:
        "Welcome to the official Hardcore Buddhist website. Discover albums, EPs, mixes, and exclusive content featuring psychedelic chillout and progressive beats. Dive into hypnotic soundscapes!",
      keywords: [
        "Hardcore Buddhist",
        "Psybient",
        "Progressive Chill Out",
        "Chillgressive",
        "Psychedelic Chillout",
        "Electronic Music",
        "Chillout Beats",
        "Progressive Beats",
        "Ambient Music",
        "Hypnotic Soundscapes",
        "Netherlands",
        "Ukraine",
      ],
    },
    discography: {
      title: "Hardcore Buddhist Discography | Albums & EPs",
      description:
        "Listen to Hardcore Buddhist’s complete discography – albums, EPs, and collaborations with Zero Cult, Lab's Cloud, Astronaut Ape, Side Liner, Kick Bong, Zymosis, and more. Released on Cosmicleaf records, Vertigo records, Mystic Sound Records, Sentimony records, and Microcosmos records. Psybient, psychedelic and progressive chillout music.",
      keywords: [
        "Hardcore Buddhist Discography",
        "Psybient Music",
        "Progressive Chillout",
        "Cosmicleaf Records",
        "Mystic Sound Records",
        "Psychedelic Chillout",
        "Electronic Music Albums",
        "Collaborations",
        "Chillout Releases",
        "Hypnotic Music",
        "Microcosmos Records",
        "Tweak Peak Records",
        "Sentimony Records",
        "Vertigo Records",
      ],
    },
    mixes: {
      title:
        "Hardcore Buddhist Mixes and Lives | Psybient & Progressive Sounds",
      description:
        "Experience mind-expanding mixes and lives from Hardcore Buddhist – deep psybient, chillgressive, and psychill vibes with hypnotic grooves and immersive sound design.",
      keywords: [
        "Hardcore Buddhist Mixes",
        "Psybient Mixes",
        "Chillgressive Music",
        "Psychill Mixes",
        "Progressive Sounds",
        "Hypnotic Grooves",
        "Immersive Sound Design",
        "Live Sets",
        "Psybient Vibes",
        "Psychedelic electronica",
      ],
    },
    videos: {
      title: "Hardcore Buddhist | Official Music Videos & Visual Journeys",
      description:
        "Watch Hardcore Buddhist’s mesmerizing music videos – trippy psychedelic visuals and immersive sonic experiences blending chillout and progressive electronica.",
      keywords: [
        "Hardcore Buddhist Music Videos",
        "Psychedelic Visuals",
        "Psybient Videos",
        "Progressive Electronica",
        "Chillout Music Videos",
        "Trippy Visuals",
        "Electronic Music Videos",
        "Hypnotic Journeys",
        "Immersive Sonic Experiences",
      ],
    },
    gigs: {
      title:
        "Hardcore Buddhist Live Gigs & Events | Psybient & Progressive Chill Out Shows",
      description:
        "Join Hardcore Buddhist at upcoming gigs and festivals. Experience live psychedelic chillout, progressive grooves, and hypnotic beats on stage! Performing at festivals across Europe and beyond.",
      keywords: [
        "Hardcore Buddhist Gigs",
        "Live Gigs",
        "Live Psybient Music",
        "Progressive Chillout Events",
        "Psybient Festivals",
        "Psytrance Live Shows",
        "Psychedelic Chillout Gigs",
        "Electronic Music Festivals",
        "Hardcore Buddhist Live Performances",
        "Soria Gathering",
        "Lares Gathering",
        "Kosmos Festival",
        "Yaga Gathering",
        "Psychedelic Rave",
        "Radiozora",
        "Psylan Festival",
      ],
    },
    merch: {
      title: "Hardcore Buddhist Merchandise | CD Albums & Upcoming Collections",
      description:
        "Buy the Hardcore Buddhist CD album <Succulent 432Hz> and stay tuned for new collections of clothing and accessories coming soon.",
      keywords: [
        "Hardcore Buddhist Merchandise",
        "Psybient Merchandise",
        "Succulent 432Hz Album",
        "Music CD Merch",
        "Psybient Merch",
        "Progressive Chillout Merchandise",
      ],
    },
    about: {
      title: "About Hardcore Buddhist | Psybient & Progressive Chillout Artist",
      description:
        "Discover the story of Hardcore Buddhist – an electronic music project blending psybient, progressive chill out and techno beats. Performing at festivals across Europe and beyond.",
      keywords: [
        "Hardcore Buddhist Bio",
        "Psybient Artist",
        "Progressive Chillout",
        "Psybient Music",
        "Electronic Music Project",
        "Progressive Chillout Artist",
        "Festival Performances",
        "Hardcore Buddhist Story",
      ],
    },
    contact: {
      title: "Contact Hardcore Buddhist | Booking & Inquiries",
      description:
        "Get in touch with Hardcore Buddhist for bookings, collaborations, and inquiries. Let’s connect and create magical sonic experiences together.",
      keywords: [
        "Hardcore Buddhist Booking",
        "Psybient Music Booking",
        "Progressive Chillout Bookings",
        "Electronic Music Collaborations",
        "Hardcore Buddhist Inquiries",
        "Live Music Booking",
        "Psybient Artist Contact",
        "Collaborations Inquiries",
        "Booking Hardcore Buddhist",
      ],
    },
  },

  swaratrip: {
    homepage: {
      title: "Swaratrip | Goa & Forest Psytrance Project",
      description:
        "Born in Ukraine, based in Amsterdam, Netherlands. Swaratrip delivers immersive Goa and Forest Psytrance experiences, blending classic and modern psychedelic realms. Released music on Timewarp, Neogoa Records, Vertigo Records, and more.",
      keywords:
        "goa trance, forest psytrance, swaratrip music, psychedelic electronic music, psytrance producer, psytrance DJ, dutch psytrance scene, Ukrainian psytrance artist",
    },
    discography: {
      title: "Swaratrip Discography | Goa & Forest Psytrance Releases",
      description:
        "Explore the discography of Swaratrip, featuring albums, EPs, and collaborations with Braincell, Blue Planet Corporation, Alienapia, Artha, Cosmic Dimensions, Lacerta, Thenaria and more. Released on Timewarp, Vertigo records, Neogoa Records, and Goa Records.",
      keywords:
        "swaratrip discography, goa trance albums, psytrance EPs, forest psytrance music, psychedelic trance releases, trance collaborations, Amsterdam psy scene",
    },
    mixes: {
      title:
        "Swaratrip Mixes and Lives | Psychedelic Goa & Forest Psytrance Sets",
      description:
        "Listen to exclusive mixes from Swaratrip, blending Goa and Forest Psytrance into high-energy festival experiences. Performed at festivals in Netherlands, Norway, Germany, Oman and beyond.",
      keywords:
        "swaratrip DJ sets, psytrance mixes, goa trance DJ, forest psytrance sessions, festival DJ mixes, Amsterdam psytrance artist, psychedelic DJ",
    },
    videos: {
      title: "Swaratrip Videos | Live Sets & Psytrance Visuals",
      description:
        "Watch live performances, music videos, and psychedelic visuals from Swaratrip. Experience the energy of Goa and Forest Psytrance through captivating audiovisual journeys.",
      keywords:
        "psytrance live set, swaratrip music videos, psychedelic trance visuals, goa trance performances, festival DJ recordings, Amsterdam psytrance events",
    },
    gigs: {
      title: "Swaratrip Tour & Gigs | Upcoming Psytrance Festival Performances",
      description:
        "Check out upcoming gigs and past performances from Swaratrip at major psytrance festivals across Europe and beyond. Shared the stage with Braincell, Atriohm, Electric Universe, and more.",
      keywords:
        "swaratrip tour dates, psytrance gigs, goa trance festival performances, trance DJ bookings, Amsterdam psy scene, international psytrance artist",
    },
    about: {
      title: "About Swaratrip | Goa & Forest Psytrance Artist",
      description:
        "Born in Ukraine, based in Amsterdam, Netherlands. Swaratrip is a psychedelic trance project blending Goa and Forest Psytrance. With 15+ years in electronic music production, the project delivers deep, immersive psychedelic journeys.",
      keywords:
        "about swaratrip, psytrance artist bio, goa trance producer, Amsterdam psytrance DJ, Ukrainian electronic musician, psychedelic music creator",
    },
    contact: {
      title: "Contact Swaratrip | Psytrance Bookings & Inquiries",
      description:
        "Get in touch with Swaratrip for booking inquiries, collaborations, and festival performances. Based in Amsterdam, performing internationally.",
      keywords:
        "contact swaratrip, psytrance bookings, goa trance DJ hire, festival performances, Amsterdam trance artist, electronic music collaborations",
    },
  },

  mindsex: {
    homepage: {
      title:
        "Mindsex | Melodic House, Techno & Progressive Trance – Official Website",
      description:
        "Discover Mindsex – an emerging electronic music project fusing melodic house, techno, and progressive trance. Dive into emotive soundscapes and cutting-edge production from Netherlands-based producer Ihor Morozov.",
      keywords: [
        "Melodic House",
        "Melodic Techno",
        "Progressive Trance",
        "Deep House",
        "Progressive House",
        "Electronic Music",
        "Netherlands Music Producer",
        "Underground House",
        "Festival DJ",
        "Melodic Progressive",
        "Deep Progressive Techno",
      ],
    },
    discography: {
      title: "Mindsex Discography | Releases & Tracks",
      description:
        "Explore the complete discography of Mindsex – featuring innovative melodic house, techno, and progressive trance releases. Stream albums, EPs, and singles with hypnotic grooves and deep emotions.",
      keywords: [
        "Mindsex Discography",
        "Melodic House Tracks",
        "Melodic Techno Releases",
        "Progressive Trance Tracks",
        "Electronic Music Discography",
        "New Melodic House Music",
        "Progressive House EP",
        "Melodic Techno Album",
        "Best Melodic Techno 2025",
      ],
    },
    mixes: {
      title: "Mindsex Mixes and Lives | Deep & Melodic Sets",
      description:
        "Listen to exclusive DJ mixes and live sets from Mindsex – blending deep, progressive, and melodic house with hypnotic grooves, storytelling, and emotional journeys.",
      keywords: [
        "Mindsex DJ Mixes",
        "Melodic House Mix",
        "Melodic Techno Live Set",
        "Progressive House DJ Mix",
        "Deep Progressive Mix",
        "Festival DJ Set",
        "Melodic Progressive Techno Mix",
        "Chill Progressive Set",
      ],
    },
    videos: {
      title: "Mindsex Music Videos | Visual & Sonic Experience",
      description:
        "Watch official music videos and live performances from Mindsex – a project exploring the deeper, cinematic, and more thought-provoking side of electronic music.",
      keywords: [
        "Mindsex Music Video",
        "Melodic Techno Video",
        "Melodic House Visual",
        "Progressive Trance Video",
        "Electronic Music Video",
        "Trippy Music Video",
        "Psychedelic Visuals",
        "Cinematic Electronic Music",
      ],
    },
    gigs: {
      title: "Mindsex Shows and Gigs | Upcoming Events",
      description:
        "Check out upcoming Mindsex gigs and festival appearances. Join live sets packed with hypnotic melodies, progressive beats, and emotional journeys through electronic soundscapes.",
      keywords: [
        "Mindsex Live",
        "Mindsex Gigs",
        "Melodic House Festival",
        "Melodic Techno Event",
        "Progressive Trance Live",
        "Netherlands DJ Booking",
        "Electronic Music Festival",
        "Progressive House DJ Set",
      ],
    },
    about: {
      title: "About Mindsex | The Vision Behind The Sound",
      description:
        "Mindsex is the latest evolution of Netherlands-based producer Ihor Morozov – blending melodic house, techno, and progressive trance into intelligent, emotional, and hypnotic soundscapes.",
      keywords: [
        "About Mindsex",
        "Ihor Morozov",
        "Melodic House Producer",
        "Melodic Techno Artist",
        "Progressive Trance Producer",
        "Electronic Music Producer",
        "Netherlands DJ",
        "Deep Melodic House",
        "Melodic Progressive Trance",
      ],
    },
    contact: {
      title: "Contact Mindsex | Booking & Inquiries",
      description:
        "Get in touch with Mindsex for bookings, collaborations, press, and inquiries. Let’s create unforgettable electronic music experiences together.",
      keywords: [
        "Mindsex Booking",
        "Contact Mindsex",
        "DJ Booking Netherlands",
        "Electronic Music Collaboration",
        "Melodic Techno Booking",
        "Melodic House DJ Booking",
        "Festival Booking",
        "Electronic Press Kit",
      ],
    },
  },
};
